import React, { useEffect} from "react";
import { BiPlusCircle } from "react-icons/bi";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Breadcrumb from "../common/Breadcrumb";

const Activities = () => {  

  const images = [
    { id: 1, src: "images/gallery/activities-1.png", alt: "activities", title: "activities", group: "activities" },
    { id: 2, src: "images/gallery/activities-2.png", alt: "activities", title: "activities", group: "activities" },
    { id: 3, src: "images/gallery/activities-3.png", alt: "activities", title: "activities", group: "activities" },
    { id: 3, src: "images/gallery/activities-4.png", alt: "activities", title: "activities", group: "activities" },
    { id: 3, src: "images/gallery/activities-5.png", alt: "activities", title: "activities", group: "activities" },
    { id: 3, src: "images/gallery/activities-6.png", alt: "activities", title: "activities", group: "activities" },
    { id: 3, src: "images/gallery/activities-7.png", alt: "activities", title: "activities", group: "activities" },
    { id: 3, src: "images/gallery/activities-8.png", alt: "activities", title: "activities", group: "activities" },
  ];

  useEffect(() => {
    NativeFancybox.bind("[data-fancybox='gallery']", {
      infinite: true,
      Toolbar: {
        display: {
          left: ["infobar"],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Thumbs: {
        autoStart: false,
      },
      caption: (fancybox, slide) => {
        return slide.$trigger?.dataset?.caption || slide.$trigger?.title || "";
      },
    });

    return () => {
      NativeFancybox.destroy();
    };
  }, []);


  return (
    <>
      <Breadcrumb
        pageTitle="Gallery"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Playground Activities for Children" },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="section-title">
                <h2>Playground Activities for Children</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="my-shuffle-container row columns-4 popup-gallery full-screen">
                {images.map((image) => (
                  <div key={image.id} className="grid-item" data-group={image.group}>
                    <div className="portfolio-item">
                      <div className="position-relative">
                        <img
                          className="img-fluid"
                          src={image.src}
                          alt={image.alt}
                          loading="lazy"
                        />
                        <div className="portfolio-overlay">
                          <a
                            data-fancybox="gallery"
                            data-caption={image.title}
                            href={image.src}
                            title={image.title}
                            className="portfolio-img"
                          >
                            <i>
                              <BiPlusCircle size={40} />
                            </i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

               <div className="description pt-4">
                <p className="description-text">
                  Encouraging creativity and imagination through drawing, painting, and craft activities.

                </p>
              
                <p className="description-text">
                 The Creative Art & Craft Room provides a vibrant and inspiring environment where students explore their imagination through drawing, painting, sculpting, and various craft activities. Equipped with quality art materials and guided by skilled instructors, the room encourages creative expression and the development of fine motor skills.


                </p>
              <p className="description-text">
                 Through structured and free-hand activities, students learn to transform ideas into meaningful creations. The space nurtures originality, aesthetic appreciation, and confidence, fostering artistic growth alongside academic development.


                </p>
          </div>      
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Activities;
